import React from 'react';
import * as S from './StepList.styles';

/**
 * Numbered step list block for how-to-play pages.
 * Optional `title` renders a group heading above the steps (e.g. "Preparación").
 * `size="sm"` renders a more compact variant for steps nested inside modes.
 *
 * Props:
 *  - steps: [{ title: string, description: string }]
 *  - title?: string
 *  - startIndex?: number (default 1)
 *  - size?: 'lg' | 'sm'
 */
const StepList = ({ steps = [], title, startIndex = 1, size = 'lg' }) => {
  if (!Array.isArray(steps) || steps.length === 0) {
    return null;
  }

  return (
    <S.Group $size={size}>
      {title && <S.GroupTitle $size={size}>{title}</S.GroupTitle>}
      <S.List>
        {steps.map((step, idx) => (
          <S.StepItem key={idx} $size={size} style={{ animationDelay: `${(idx * 0.06).toFixed(2)}s` }}>
            <S.StepNumber $size={size}>{startIndex + idx}</S.StepNumber>
            <S.StepContent>
              <S.StepTitle $size={size}>{step.title}</S.StepTitle>
              {step.description && <S.StepDescription>{step.description}</S.StepDescription>}
            </S.StepContent>
          </S.StepItem>
        ))}
      </S.List>
    </S.Group>
  );
};

export default StepList;
